(function (Drupal, once) {

  Drupal.behaviors.staffCategoryTitle = {
    attach: function (context, settings) {
      const titles = once('staff-category-titles', '.staff--category--title', context);

      titles.forEach((title) => {
        if(title.textContent.includes('Departement') || title.textContent.includes('Department') || title.textContent.includes('Directie') || title.textContent.includes('Management') || title.textContent.includes('partners')){
          title.classList.add("staff--category--main")
        }
      });
    }
  }

}(Drupal, once));
